const prefix = "WEBSOCKET::";

export const CONNECT = `${prefix}CONNECT`;
export const DISCONNECT = `${prefix}DISCONNECT`;
export const SEND_MESSAGE = `${prefix}SEND_MESSAGE`;